// Marketplace tile skeleton — actual ProductCard tuzilishini takrorlaydi:
// aspect-square rasm + title (2 qator) + DON narxi.
export default function ProductCardSkeleton() {
  return (
    <div className="rounded-2xl bg-gray-4 border border-white/[0.04] overflow-hidden">
      <div className="w-full aspect-square skeleton" />
      <div className="px-3 py-2.5">
        <div className="space-y-1.5 min-h-[36px]">
          <div className="w-full h-3 skeleton rounded" />
          <div className="w-2/3 h-3 skeleton rounded" />
        </div>
        <div className="flex items-center gap-1 mt-1.5">
          <div className="size-3.5 skeleton rounded" />
          <div className="w-12 h-3.5 skeleton rounded" />
        </div>
      </div>
    </div>
  );
}
